import React from 'react';

const PageLoading = () => (
  <div className="page-spinner-bar">
    <div className="bounce1"/>
    <div className="bounce2"/>
    <div className="bounce3"/>
  </div>
);

export const Loader = () => (
  <h5 className="text-center">
    <i className="fa fa-circle-o-notch fa-spin" />
  </h5>
);

export const LoaderInline = () => (
  <i className="fa fa-circle-o-notch fa-spin" />
);

export default PageLoading;
